import Vue from 'vue';
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import './core/index.js';
import App from './App.vue';
import router from './shared/router';
import i18n from './shared/i18n';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import Fragment from 'vue-fragment';
import './modules';
import './plugins';
import './icons';
import store from './store';
import './index.scss';
import {AppSettings} from './shared/AppSettings';
import {Multiselect} from 'vue-multiselect';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import 'vue2-datepicker/index.css';
import vueDebounce from 'vue-debounce';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import ColorPickerGradient from 'vue2-color-picker-gradient';

const Rollbar = require('vue-rollbar');
Vue.use(ColorPickerGradient);
Vue.use(require('vue-moment'));
Vue.use(Fragment.Plugin);
Vue.use(vueDebounce);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.component('Multiselect', Multiselect);
Vue.component('Treeselect', Treeselect);

Vue.use(VueVirtualScroller);

Vue.config.productionTip = false;
if (AppSettings.isProduction() && process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN) {//temp check for access token
  Vue.use(Rollbar, {
    accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: process.env.NODE_ENV,
    payload: {
      client: {
        javascript: {
          code_version: '1.0',
        },
      },
    },
  });

  Vue.config.errorHandler = (err, vm, info) => {
    Vue.rollbar.error(err);
  };
  Vue.config.warnHandler = function (msg, vm, trace) {
    // `trace` is the component hierarchy trace
    Vue.rollbar.warning(msg + trace);
  };
}

Vue.filter('numFormat', numFormat(numeral));
new Vue({
  i18n,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
